import { render } from "./F2TabstripContent.vue?vue&type=template&id=2cb9b5fe&scoped=true&ts=true"
import script from "./F2TabstripContent.vue?vue&type=script&lang=ts"
export * from "./F2TabstripContent.vue?vue&type=script&lang=ts"

import "./F2TabstripContent.vue?vue&type=style&index=0&id=2cb9b5fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb9b5fe"]])

export default __exports__